<template>
  <Class />
</template>

<script>
import Class from '@/components/content/classes/EditSelectedClass.vue'

export default {
  name: 'ContentClassHistory',
  components: { Class }
}
</script>

<style scoped>

</style>
